var _mask, _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProgress10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_381_490",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C12.3878 2.8474e-08 14.6967 0.854396 16.5094 2.40869C18.322 3.96298 19.5187 6.11458 19.8829 8.4744C20.2472 10.8342 19.7551 13.2465 18.4955 15.2751C17.236 17.3036 15.2921 18.8145 13.0155 19.5345C10.7388 20.2545 8.27972 20.1362 6.08277 19.2008C3.88582 18.2655 2.09606 16.5749 1.03714 14.4348C-0.0217838 12.2946 -0.279972 9.84623 0.30926 7.5323C0.898492 5.21837 2.29625 3.19165 4.24978 1.81862L10 10L10 0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C12.3878 2.8474e-08 14.6967 0.854396 16.5094 2.40869C18.322 3.96298 19.5187 6.11458 19.8829 8.4744C20.2472 10.8342 19.7551 13.2465 18.4955 15.2751C17.236 17.3036 15.2921 18.8145 13.0155 19.5345C10.7388 20.2545 8.27972 20.1362 6.08277 19.2008C3.88582 18.2655 2.09606 16.5749 1.03714 14.4348C-0.0217838 12.2946 -0.279972 9.84623 0.30926 7.5323C0.898492 5.21837 2.29625 3.19165 4.24978 1.81862L10 10L10 0Z",
    fill: "#09702B",
    stroke: "#09702B",
    strokeWidth: 4,
    mask: "url(#path-1-inside-1_381_490)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    transform: "rotate(-90 10 10)",
    stroke: "#09702B",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress10);
export default __webpack_public_path__ + "static/media/progress10.9ab0412990ebc98e7fa463c8407614bd.svg";
export { ForwardRef as ReactComponent };